// project imports
import Logo from "./logo";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => <Logo width={104} />;

export default LogoSection;
